import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const SectionHeader = styled.div<{ border?: boolean }>`
  padding: 16px 0;
  margin: 0 12px;
  border-bottom: ${(props) => props.border && `1px solid ${colors.gray200}`};
`;

export const SectionBody = styled.div`
  padding: 8px 12px 0;
  margin-bottom: 12px;
`;
